<template>
    <div>
        <div
            v-for="(file, index) in files"
            :key="index"
            class="files"
            :class="{ 'files--added': acceptedFilesIds.includes(file?.file?.id) }"
            @click="addFile(file)"
        >
            <span>{{ file.file.name }}</span>
        </div>
    </div>
</template>

<script>
    import ReferralsAPI from 'api/ReferralsAPI'
    export default {
        props: {
            files: { type: Array, required: true },
        },

        data() {
            return {
                acceptedFilesIds: [],
            }
        },

        methods: {
            addFile(file) {
                if (this.acceptedFilesIds.includes(file?.file?.id)) {
                    return
                }
                ReferralsAPI.uploadConsultationNotes([file]).then(() => {
                    this.acceptedFilesIds.push(file.file.id)
                    this.emitEvent({ name: 'file-added', payload: file })
                })
            },
        },

        watch: {},

        mounted() {},
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    .files {
        border: 1px solid $color--accent-1;
        color: $color--accent-1;
        background-color: $color--bg-dashboard;
        margin: 10px 0;
        width: auto;
        max-width: 300px;
        border-radius: 10px;
        font-weight: 500;

        &--added {
            border: 1px solid $color--accent-3;
            color: $color--accent-3;
            background-color: $color--accent-17;
        }

        &:hover {
            border: 1px solid $color--accent-3;
            color: $color--accent-3;
            background-color: $color--accent-17;
            cursor: pointer;
        }
    }
</style>
